export default "__VITE_ASSET__88TZI6VY__"